import React from "react";
import {defineBlock, useSmartProp, smartProps, useInspectorControl, useEditor} from "@smartfire/wordpress-react";
import { PanelColorSettings } from '@wordpress/block-editor';

import style from "./block.module.scss";

function Inspector(){
    const [color, setColor] = useSmartProp("color");
    return <PanelColorSettings
                title='Couleur'
                colorSettings={[
                    {
                        value: color,
                        onChange: (color) => setColor(color),
                        label: "Couleur spacer"
                    }
                ]}
            />;
}

function Block({color}){
    const {isEditing} = useEditor();
    useInspectorControl(Inspector);
    return  (
        <div className={style.block}>
            {isEditing && 'Séparateur Coloré:'}
            <div style={{ borderColor: color }} className={style.separator}/>
        </div>
    )
}

export default defineBlock({
    Block, 
    smartProps: {
        color: smartProps.string.withDefault("#fff"),
    },
    setup: {
        title: "Separateur"
    }
});
